export default class FeedbackEventData {
    public id: number;
    public key: string;
    public name: string;
    public description: string;
    public hasRating: boolean;
    public hasComment: boolean;
    public createdAt: string;
    public updatedAt: string;
    
    constructor(
        id: number,
        key: string,
        name: string,
        description: string,
        hasRating: boolean,
        hasComment: boolean,
        createdAt: string,
        updatedAt: string|null,
    ) {
        this.id = id;
        this.key = key;
        this.name = name;
        this.description = description;
        this.hasRating = hasRating;
        this.hasComment = hasComment;
        this.createdAt = createdAt;
        this.updatedAt = updatedAt;
    }
}
